/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDownhillSkiingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-downhill-skiing"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M18.45 23.57Q17.8 23.57 17.15 23.48Q16.5 23.38 15.9 23.15L2.52 18.3Q2.1 18.15 1.91 17.74Q1.73 17.32 1.88 16.9Q2.02 16.48 2.44 16.29Q2.85 16.1 3.27 16.25L9.15 18.4L10.7 14.45L7.28 10.88Q6.47 10.07 6.64 8.95Q6.8 7.83 7.8 7.25L11.28 5.25Q11.75 4.97 12.28 4.94Q12.8 4.9 13.28 5.08Q13.75 5.28 14.11 5.64Q14.47 6 14.65 6.53L14.97 7.6Q15.25 8.53 15.86 9.25Q16.48 9.97 17.3 10.4L17.5 9.85Q17.63 9.43 18.01 9.24Q18.4 9.05 18.82 9.18Q19.25 9.3 19.45 9.7Q19.65 10.1 19.52 10.53L18.52 13.53Q16.55 13.18 15.04 12.07Q13.53 10.97 12.8 9.32L10.93 10.38L13.3 13.07Q13.55 13.35 13.6 13.71Q13.65 14.07 13.53 14.43L11.65 19.3L14.13 20.2L16 14.5Q16.5 14.7 17.01 14.82Q17.52 14.95 18.02 15.07L16.13 20.95L16.6 21.13Q17.02 21.27 17.49 21.35Q17.95 21.43 18.45 21.43Q18.8 21.43 19.16 21.38Q19.52 21.32 19.88 21.23Q20.3 21.1 20.73 21.26Q21.15 21.43 21.35 21.82Q21.55 22.25 21.38 22.65Q21.2 23.05 20.77 23.18Q20.18 23.38 19.6 23.48Q19.02 23.57 18.45 23.57ZM16.95 6.2Q16.95 6.2 16.5 6.2Q16.05 6.2 15.4 5.55Q14.75 4.9 14.75 4Q14.75 3.1 15.4 2.45Q16.05 1.8 16.95 1.8Q17.85 1.8 18.5 2.45Q19.15 3.1 19.15 4Q19.15 4.9 18.5 5.55Q17.85 6.2 16.95 6.2Z" fill={color} />
    </svg>
  );
}
